jQuery(document).ready(function($) {

    if(jQuery('.group-one-header-banner').length > 0){
        jQuery('body').addClass('hasHeaderBanner');
        setTimeout(function() {
            bannerSetUp();
            mobileTabsSizing();
        }, 1000);

        jQuery(window).resize(function(){
            bannerSetUp();
        });
        if($('body').hasClass('page-vehicle-display-page')){
            if($('.vdp--lightning').length){
                $('.group-one-header-banner').css('position', 'absolute');
            }else{
                var getHeaderPosition = $('#header').css('position');
                $('.group-one-header-banner').css('position', getHeaderPosition);
            }
        }
    }
    else{
        if(jQuery("#custom-mobile-tabs .pm-cta").length > 0){
            jQuery("#custom-mobile-tabs").closest("html").addClass("has-mobile-tiles");
        }
    }

    $('.mobile-menu-toggle').sidr({
        name: 'mobile-nav-menu',
        side: 'right',
        source: '.mobile-nav-menu',
        renaming: false,
        onOpen: function(){
            $(".menu-top").animate({left:-260});
        },
        onClose: function(){
            $(".menu-top").animate({left:0});
        }
    });

    $('.close-mobile-nav').bind('click', function () {
      $.sidr('close', 'mobile-nav-menu')
    })

    function bannerSetUp(){
        var bannerHeight = $(".group-one-header-banner").height();
        jQuery("#whitewrap").css("margin-top", bannerHeight+"px");
        jQuery("#header, .menu-top").css("top", bannerHeight+"px");
    }

    function mobileTabsSizing(){
        if(jQuery(window).width() <  768){
            var bannerHeight = $(".group-one-header-banner").height();
            if(jQuery("#custom-mobile-tabs .pm-cta").length > 0){
                jQuery("#custom-mobile-tabs").closest("html").addClass("has-mobile-tiles");
                var customTabsTop = jQuery("#custom-mobile-tabs").css("top");
                var customTabCallTop = jQuery("#custom-mobile-tabs .pm-call-dropdown").css("top");
                var fixedTopSpacerHeight = jQuery(".visible-sm .fixed-top-spacer").css("height");
                var customTopHeight = jQuery("#custom-mobile-tabs").height();

                fixedTopSpacerHeight = fixedTopSpacerHeight.slice(0, -2);
                fixedTopSpacerHeight = parseInt(fixedTopSpacerHeight);

                customTopHeight = parseInt(customTopHeight);

                fixedTopSpacerHeight = fixedTopSpacerHeight + customTopHeight;

                customTabsTop = customTabsTop.slice(0, -2);
                customTabsTop = parseInt(customTabsTop);
                customTabsTop = bannerHeight + customTabsTop;

                customTabCallTop = customTabCallTop.slice(0, -2);
                customTabCallTop = parseInt(customTabCallTop);
                customTabCallTop = bannerHeight + customTabCallTop;

                jQuery("#custom-mobile-tabs").css("top", customTabsTop);
                jQuery("#custom-mobile-tabs .pm-call-dropdown").css("top", customTabCallTop)
                jQuery(".fixed-top-spacer").css("height", fixedTopSpacerHeight);

                if(jQuery("body").hasClass("page-vehicle-display-page")){
                    var vdpButton = jQuery("#vehicleDetails .maincta-row.ctabox-row a[data-gtm-event='vdpPrimaryCTA']").css("top");
                    vdpButton = vdpButton.slice(0, -2);
                    vdpButton = parseInt(vdpButton);
                    vdpButton = vdpButton + bannerHeight;
                    jQuery("#vehicleDetails .maincta-row.ctabox-row a[data-gtm-event='vdpPrimaryCTA']").css("top", vdpButton);
                }
            }
        }
    }
});
